import { render, staticRenderFns } from "./WagonDialogUtiDetails.vue?vue&type=template&id=28639c39&scoped=true"
import script from "./WagonDialogUtiDetails.vue?vue&type=script&lang=js"
export * from "./WagonDialogUtiDetails.vue?vue&type=script&lang=js"
import style0 from "./WagonDialogUtiDetails.vue?vue&type=style&index=0&id=28639c39&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28639c39",
  null
  
)

export default component.exports